import React, { useContext, useEffect, useRef } from 'react';
import { checkMinMaxVolume } from '../../../utilities/instrumentInfo';
import { TradeContext } from '../../trading-dialog/context/TradeContextProvider';
import { Input } from '@vt/vt-ui';

const QuickLotSize = () => {
  const { instrumentInfo, lotSize, handleLotSize, inputLotSize, validateLotSize } =
    useContext(TradeContext);
  const ref = useRef();
  useEffect(() => {
    if (lotSize && typeof lotSize === 'number') {
      ref.current.value = lotSize.toFixed(2);
    }
  }, [lotSize]);

  return (
    <div>
      <Input
        label="Volume"
        ref={ref}
        onChange={({ target: { value } }) => inputLotSize(value)}
        onBlur={({ target: { value } }) => validateLotSize(value)}
        type="number"
        value={lotSize.toLocaleString()}
        className='vt-flex-1 w-full bg-transparent text-body3 outline-none placeholder:vt-text-neutral-300 focus:vt-caret-neutral-900 dark:vt-text-neutral-white dark:placeholder:vt-text-[#9f9f9f] dark:focus:vt-caret-primary-500'
      />
    </ div>
  )

  // return (
  //   <div className="box-lotsize">
  //     <span className="text-lebel">Lot size</span>
  //     <input
  //       ref={ref}
  //       className="lot-size"
  //       onChange={({ target: { value } }) => inputLotSize(value)}
  //       onBlur={({ target: { value } }) => validateLotSize(value)}
  //       type="number"
  //       value={lotSize.toLocaleString()}
  //     />
  //     <div className="lotsite-panel">
  //       <button
  //         className="lotsit-button-up"
  //         disabled={checkMinMaxVolume('max', lotSize, instrumentInfo?.volume_max).con}
  //         onClick={() => handleLotSize('dec')}>
  //         +
  //       </button>
  //       <button
  //         className="lotsit-button-down"
  //         disabled={lotSize === 0}
  //         onClick={() => handleLotSize('inc')}>
  //         -
  //       </button>
  //     </div>
  //   </div>
  // );
};

export default QuickLotSize;
